import React, { useEffect, forwardRef } from "react";
import { Link } from "react-router-dom";
import Pagination from "./pagination";
import { useDispatch, useSelector } from "react-redux";
import { listProduct } from "../../Redux/Actions/ProductActions";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";

const ShopSection = forwardRef((props, ref) => {
  const { keyword, pagenumber } = props;
  const dispatch = useDispatch();
  
  const currentPage = Number(pagenumber) || 1;

  const productList = useSelector((state) => state.productList);
  const { loading, error, products, page, pages } = productList;

  // Fetch products
  useEffect(() => {
    dispatch(listProduct("", keyword, currentPage));
  }, [dispatch, keyword, currentPage]);

  // Scroll to top of shop section on page change
  useEffect(() => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [currentPage]);

  return (
    <div ref={ref} className="shop-sec-container">
      <div className="shop-sec-section">
        <div className="shop-sec-row">
          <div className="shop-sec-article">
            <div className="shop-sec-products-grid">
              {loading ? (
                <div className="shop-sec-loading">
                  <Loading />
                </div>
              ) : error ? (
                <Message variant="alert-danger">{error}</Message>
              ) : (
                <>
                  {/* Debug output */}
                  {console.log("Rendering products:", products)}
                  
                  {products && products.length > 0 ? (
                    products.map((product) => (
                      <div
                        className="shop-sec-product-item"
                        key={product._id}
                      >
                        <div className="shop-sec-border-product">
                          <Link to={`/products/${product._id}`}>
                            <div className="shop-sec-image-container">
                              <img src={product.image} alt={product.name} />
                            </div>
                          </Link>

                          <div className="shop-sec-product-info">
                            <p>
                              <Link to={`/products/${product._id}`}>
                                {product.name}
                              </Link>
                            </p>

                            {/* <Rating
                              value={product.rating}
                              text={`${product.numReviews} reviews`}
                            /> */}
                            <h3>Size: {product.size || "N/A"}</h3>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="shop-sec-no-products">
                      <p>No products found. Debug: {JSON.stringify({ products })}</p>
                    </div>
                  )}
                </>
              )}

              {/* Only show pagination if we have pages */}
              {!loading && !error && pages > 0 && (
                <div className="shop-sec-pagination">
                  <Pagination
                    pages={pages}
                    page={page}
                    keyword={keyword ? keyword : ""}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ShopSection;